module.exports = __webpack_public_path__ + "static/img/g_stomach_ok.25fb4cee.webp";